import { NewUser } from './newUser';

export class UserInfo {
    clientStatus:string;
    accessLevel:string;
    sortValue:string;
    avilableWithin: string;
    isOnlineExam: boolean;
    isOnlinePaper:boolean;
    isActiveForExam: boolean;
    startAt: string;
    marks: string;
    isResultsReleased: boolean;
    user:NewUser;
    constructor(values: Object = {}) {
        Object.assign(this, values);
    }
}

export class PaperSet {
    _id:string;
    clientStatus:string;
    brandImage: string;
    brandName: string;
    createdBy: NewUser;
    startAt: string;
    createdAt:string;
    currentTime:string;
    price: number;
    relesedAt:string;
    accessLevel:string;
    resultReleaseAt: string;
    isOnlinePaper:boolean;
    status:string;
    summary:string;
    title:string;
    isResultsReleased: boolean;
    buttonStatus : string;
    buyButtonColor: string;
    paperSetType: string;
    userInfo : UserInfo;
    constructor(values) {
        Object.assign(this, values);
        this.userInfo = new UserInfo(values.userInfo);
        this.createdBy = new NewUser(values.createdBy ? values.createdBy : {firstname: '', lastname : null});
    }

    getCreatedBy(){
        return this.createdBy.firstname || this.createdBy.lastname ? this.createdBy.firstname + ' ' + this.createdBy.lastname : '';
    }
}


// WEBPACK FOOTER //
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/app/core-modules/model/paperSet.ts